import { isPromotionForbidden } from './isPromotionForbidden';
import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { hasTopOrPremium } from './hasTopOrPremium';

export const isPromotionToggleDisabled = (response: IAddFormPublishTermsResponse) => {
  const isBlockedOfferPublishBySanctions = isPromotionForbidden(response.terms);
  const isWithoutTopAndPremium = hasTopOrPremium(response);

  return isBlockedOfferPublishBySanctions || !isWithoutTopAndPremium;
};
